const TRACKING = {
    cookieName: '_user_cookie_settings',
    optin: document.getElementById('optin'),
    buttons: document.querySelectorAll('.optin__button'),
    settings: document.getElementById('optin__settings'),
    showSettings: document.getElementById('optin__show-settings'),
    onReady() {
        // Set Tracking Properties
        if (window.location.href.indexOf('45grad.de') > -1) {
            this.gaProperty       = 'UA-43918400-4';
            this.ga4Property      = 'G-SK66ZV47B7';
            this.goProperty       = 'GTM-NVDF8B9';
            this.gtmProperty      = 'GTM-MP4F7JF';
            this.fbPixel          = '325955598079917';
            this.hjProperty       = 1264639;
            this.linkedInProperty = '1462969';
            this.leadinfoProperty = 'LI-5F74920E129D8';
        } else { // andreagrundmann.de
            this.gaProperty       = 'UA-191003943-1';
            this.ga4Property      = 'G-4QJB4D202Z';
            this.goProperty       = 'GTM-NVDF8B9';
            this.gtmProperty      = 'GTM-KFMF6R8';
            this.fbPixel          = '325955598079917';
            this.hjProperty       = 2262082;
            this.linkedInProperty = '1462969';
            this.leadinfoProperty = 'LI-6065813F57BF7';
        }
        if (TRACKING.optin !== null) {
            TRACKING.showOptin();
            TRACKING.showOptions();
            TRACKING.acceptOptin();
        }
        TRACKING.gaOptout();
        TRACKING.inputChanges();
    },
    showOptin() {
        if ( document.cookie.indexOf(TRACKING.cookieName) != -1 ) {
            TRACKING.optin.remove();
            let cookieValueStr = COOKIE.get({name: TRACKING.cookieName});
            let cookieValueArr = cookieValueStr.split(',');
            TRACKING.activateTracking({settings: cookieValueArr});
        } else {
            TRACKING.optin.style.display = 'block';
        }
    },
    acceptOptin() {
        TRACKING.buttons.forEach(button => { 
            button.addEventListener('click', event => {
                event.preventDefault();
                let cookieSettingsArr = [];
                TRACKING.settings.querySelectorAll('input').forEach(element => {
                    (element.checked) ? cookieSettingsArr.push(element.value + '=true') : cookieSettingsArr.push(element.value + '=false');                    
                });
                const storeDuration     = (cookieSettingsArr.includes('google_analytics=false')) ? 1 : 730;
                const cookieSettingsStr = cookieSettingsArr.toString();
                COOKIE.set({
                    name: TRACKING.cookieName, 
                    value: cookieSettingsStr, 
                    days: storeDuration
                });
                TRACKING.optin.remove();
                TRACKING.activateTracking({settings: cookieSettingsArr});
                TRACKING.writeFile({post: cookieSettingsStr, query: 'cookie-settings'});
                location.reload();
            });
        });
    },
    showOptions() {
        TRACKING.showSettings.addEventListener('click', () => {
            TRACKING.settings.style.display = 'block';
            TRACKING.showSettings.remove();
            TRACKING.settings.querySelectorAll('input').forEach( el => {
                el.checked = false;
            });
        });
    },
    /**
    * @settings {array} - Cookie Settings String-Array
    */
    activateTracking({settings}) {
        settings.includes('google_analytics=true') && TRACKING.googleAnalytics();
        settings.includes('google_optimize=true') && TRACKING.googleOptimize();
        settings.includes('google_tag_manager=true') && TRACKING.googleTagManager();
        settings.includes('hotjar=true') && TRACKING.hotJar();
        settings.includes('facebook_pixel=true') && TRACKING.facebookPixel();
        settings.includes('linkedin=true') && TRACKING.linkedinInsight();
        settings.includes('proven_experts=true') && TRACKING.provenExpertsWidget();
        // settings.includes('leadinfo=true') && TRACKING.leadinfo();
    },
    googleAnalytics() {
        if (document.cookie.indexOf('_ga_optout') == -1) {
            // Universal Property
            (function(i, s, o, g, r, a, m) {
                i['GoogleAnalyticsObject'] = r;
                i[r] = i[r] || function() {
                    (i[r].q = i[r].q || []).push(arguments)
                }, i[r].l = 1 * new Date();
                a = s.createElement(o),
                    m = s.getElementsByTagName(o)[0];
                a.async = 1;
                a.src = g;
                m.parentNode.insertBefore(a, m)
            })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
            ga('create', TRACKING.gaProperty, 'auto');
            ga('set', 'anonymizeIp', true);
            ga('send', 'pageview');
            TRACKING.gaEvents();
            // GA 4
            let script = document.createElement('script');
            script.src = `https://www.googletagmanager.com/gtag/js?id=${TRACKING.ga4Property}`;
            script.async = true;
            document.head.appendChild(script);
            window.dataLayer = window.dataLayer || [];
            function gtag() {
                dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', TRACKING.ga4Property);
        }
    },
    googleOptimize() {
        if (window.location.href.indexOf('45grad.de') > -1) {           
            (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
            h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
            (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
            })(window,document.documentElement,'async-hide','dataLayer',4000,
            {'GTM-NVDF8B9':true});
        } else { // andreagrundmann.de
            (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
            h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
            (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
            })(window,document.documentElement,'async-hide','dataLayer',4000,
            {'GTM-NVDF8B9':true});
        }
    },
    googleTagManager() {
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer',TRACKING.gtmProperty);
    },
    hotJar() {
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:TRACKING.hjProperty,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    },
    facebookPixel() {
        !function(f,b,e,v,n,t,s){if(f.fbq)return; n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', TRACKING.fbPixel);
        fbq('track', 'PageView');
    },
    linkedinInsight() {
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(TRACKING.linkedInProperty);
        (function(){var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);})();
    },
    provenExpertsWidget() {
        const markup = `<img 
                src="https://images.provenexpert.com/bd/e7/e086255ceb9d662250bb799c1d4f/widget_square_150_de_0.png" 
                alt="Erfahrungen &amp; Bewertungen zu 45 Grad digital GmbH" 
                width="150" 
                height="150" 
                style="border:0; width: 150px" 
            />`;
        let peWidgets = document.querySelectorAll('.provenexperts_widget');
        peWidgets.forEach(widget => {
            widget.insertAdjacentHTML('afterbegin', markup);
        });
    },
    leadinfo() {
        // (function(l,e,a,d,i,n,f,o){if(!l[i]){l.GlobalLeadinfoNamespace=l.GlobalLeadinfoNamespace||[]; l.GlobalLeadinfoNamespace.push(i);l[i]=function(){(l[i].q=l[i].q||[]).push(arguments)};l[i].t=l[i].t||n; l[i].q=l[i].q||[];o=e.createElement(a);f=e.getElementsByTagName(a)[0];o.async=1;o.src=d;f.parentNode.insertBefore(o,f);} }(window,document,"script","https://cdn.leadinfo.net/ping.js","leadinfo",TRACKING.leadinfoProperty));
    },
    gaOptout() {
        let optoutLink = document.getElementById('ga-optout');
        if (optoutLink !== null) {
            optoutLink.addEventListener('click', event => {
                event.preventDefault();
                COOKIE.set({
                    name: '_ga_optout', 
                    value: 'true', 
                    days: 1
                });
                let domain = window.location.hostname.replace('www', '');
                COOKIE.delete({
                    name: TRACKING.cookieName, 
                    domain: domain
                });
                COOKIE.delete({
                    name: '_ga', 
                    domain: domain
                });
                COOKIE.delete({
                    name: '_gid', 
                    domain: domain
                });
                COOKIE.delete({
                    name: '_gat', 
                    domain: domain
                });
                alert('Cookies wurden gelöscht.');
            });
        }
    },
    gaEvents() {
        /******************************
        * EVENT: Scroll
        ******************************/ 
        var maxScrollDepth = 0;
        var maxScrollPercentRound = 0;
        document.addEventListener('scroll', () => {
            var windowHeight       = window.innerHeight;
            var currentScrolldepth = window.scrollY + windowHeight;
            var documentHeight     = document.body.scrollHeight;
            maxScrollDepth         = (currentScrolldepth > maxScrollDepth) ? currentScrolldepth : maxScrollDepth;
            var maxScrollPercent   = maxScrollDepth / documentHeight * 100;
            var currentScrollPercentRound = Math.round(maxScrollPercent / 10) * 10;
            if (currentScrollPercentRound > maxScrollPercentRound) {
                maxScrollPercentRound = currentScrollPercentRound;
                ga('send', {
                    hitType:       'event',
                    eventCategory: 'SCROLL',
                    eventAction:   'SCROLL',
                    eventLabel:    maxScrollPercentRound
                });
            }
        });
        /******************************
        * EVENT: Footer in View
        ******************************/   
        const initalScroll = window.scrollY || window.pageYOffset;
        const footer       = document.querySelector('footer');
        const boundingTop  = footer.getBoundingClientRect().top + initalScroll;
        var seenCounter    = 0; 
        window.addEventListener('scroll', () => {
            var scroll = window.scrollY + window.innerHeight;
            if (scroll > boundingTop) {
                seenCounter++;
                if ( seenCounter === 1 ) {
                    ga('send', {
                        hitType:       'event',
                        eventCategory: 'ELEMENTS',
                        eventAction:   'IN VIEW',
                        eventLabel:    'FOOTER'
                    });
                }
            }
        });
        /******************************
        * EVENT: KLICK -> BTN_INTERN
        ******************************/ 
        let internButtons = document.querySelectorAll('.button--intern');
        internButtons.forEach(button => {
            button.addEventListener('click', () => {
                ga('send', {
                    hitType:       'event',
                    eventCategory: 'KLICK',
                    eventAction:   'BTN-INTERN',
                    eventLabel:    button.href
                });
            })
        });
        /******************************
        * EVENT: KLICK -> ACCORDEON
        ******************************/ 
        let dropdowns = document.querySelectorAll('.dropdown__detail');
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('click', () => {
                if ( dropdown.classList.contains('active') === false ) {
                    ga('send', {
                        hitType:       'event',
                        eventCategory: 'KLICK',
                        eventAction:   'OPEN ACCORDEON',
                        eventLabel:    dropdown.querySelector('.dropdown__title').innerHTML
                    });
                }
            });
        });
        /*********************
        * Get URL Parameters
        *********************/
        const queryString = window.location.search;
        const urlParams   = new URLSearchParams(queryString);
        const email       = urlParams.get('email');
        /******************************
        * EVENT: OPTIN -> BESTÄTIGUNG (Leadmagnet)
        ******************************/ 
        if (window.location.href.indexOf('/downloads/') > -1) {
            let urlArr   = window.location.href.split('/');
            let download = urlArr[urlArr.length - 2];
            if (email !== null) {
                ga('send', {
                    hitType:       'event',
                    eventCategory: 'OPTIN',
                    eventAction:   'BESTÄTIGUNG',
                    eventLabel:    'DOWNLOAD: ' + download + ' / ' + email
                });
            }
            let newReceiver = urlParams.get('new_receiver');
            if (newReceiver !== null && newReceiver === 'true') {
                ga('send', {
                    hitType:       'event',
                    eventCategory: 'OPTIN',
                    eventAction:   'BESTÄTIGUNG',
                    eventLabel:    'USER: ' + download + ' / ' + email
                });
            }
        }
        /******************************
        * EVENT: OPTIN -> BESTÄTIGUNG (Simple Double Optin)
        ******************************/ 
        if (window.location.href.indexOf('/subscribe/') > -1) {
            if (email !== null) {
                ga('send', {
                    hitType:       'event',
                    eventCategory: 'OPTIN',
                    eventAction:   'BESTÄTIGUNG',
                    eventLabel:    'USER: ' + email
                });
            }
        }
        /******************************
        * EVENT: OPTIN -> AUSTRAGUNG (Simple Double Optin)
        ******************************/ 
        if (window.location.href.indexOf('/unsubscribe/') > -1) {
            if (email !== null) {
                ga('send', {
                    hitType:       'event',
                    eventCategory: 'OPTIN',
                    eventAction:   'AUSTRAGUNG',
                    eventLabel:    'USER: ' + email
                });
            }
        }
    },
    /******************************
    * EVENT: LEAD -> FORM-AUFRUF
    * @form {node}
    * @action {string} : 'FORM-AUFRUF', 'FORM-VERSAND'
    * called in:
        - FORM.sendData()
        - OVERLAY.call()
    ******************************/ 
    formEvents({form, action}) {
        if (form === null) return;
        let cookieSettingsStr = COOKIE.get({name: TRACKING.cookieName});
        let cookieSettingsArr = cookieSettingsStr.split(',');
        if (cookieSettingsArr.includes('google_analytics=false')) return;
        let formWrapper = form.closest('.form-wrapper');
        if (formWrapper === null) return;
        let formName = formWrapper.id;
        ga('send', {
            hitType:       'event',
            eventCategory: 'LEAD',
            eventAction:   action,
            eventLabel:    formName
        });
    },
    /*********************
    * Listen to input changes
    *********************/
    inputChanges() {
        const forms = document.querySelectorAll('.form');
        forms.forEach(form => {
            let inputs = form.querySelectorAll('input');
            inputs.forEach(input => {
                input.addEventListener('change', event => {
                    let source     = form.querySelector('input[name="source"]').value;
                    let postString = `form_name=${form.dataset.formName};;form_temp_id=${form.id};;source=${source};;${input.id}=${input.value}`;
                    (input.classList.contains('form__checkbox') && input.checked) && TRACKING.writeFile({post: postString, query: 'form-tracking'});
                    (input.classList.contains('form__checkbox') === false) && TRACKING.writeFile({post: postString, query: 'form-tracking'});
                });  
            });
        });
    },
    /*********************
    * Write to file
    * @post {string} - stringified post data
    * @query {string} - handler query
    *********************/
    writeFile({post, query}) {
        let getUrl  = window.location;
        let baseUrl = getUrl.protocol + '//' + getUrl.hostname + '/';
        let handler = 'handler.XHR.php?handler=' + query;
        let xhr     = new XMLHttpRequest();
        xhr.open('POST', baseUrl + 'inc/' + handler, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = (e) => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200 && xhr.response === 'success') {
                    // console.log(xhr.response);
                }
            }
        };
        xhr.onerror = (e) => {
            console.log(xhr.response);
        };
        xhr.send(post);
    }
}